export default __webpack_public_path__ + "static/media/trams-page1400.549a763e.jpg";